<template>
    <div class="c-header-practice-mode">
        <h2 class="c-header-practice-mode__h">Pratik Modları</h2>
        <p class="c-header-practice-mode__desc">Yapmak istediğin pratiği seç.</p>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {};
</script>

<style scoped src="@/css/components/c-header-practice-mode.css"></style>